



















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AboutUsPartners extends Vue {
  get partners() {
    return [
      {
        name: 'Flare',
        displayName: this.$t('components.about.aboutUsPartners.flare.string'),
        imgSrc: 'https://static.gala.games/images/about-page/logo_flare.png',
        link: 'https://www.flare.xyz',
      },
      {
        name: 'Mazer Gaming',
        displayName: this.$t(
          'components.about.aboutUsPartners.mazerGaming.string',
        ),
        imgSrc:
          'https://static.gala.games/images/about-page/logo_mazergaming.png',
        link: 'https://www.mazer.gg',
      },
      {
        name: 'Bitrue',
        displayName: this.$t('components.about.aboutUsPartners.bitrue.string'),
        imgSrc: 'https://static.gala.games/images/about-page/logo_bitrue.png',
        link: 'https://www.bitrue.com',
      },
      {
        name: 'Brave',
        displayName: this.$t('components.about.aboutUsPartners.brave.string'),
        imgSrc: 'https://static.gala.games/images/about-page/logo_brave.png',
        link: 'https://www.brave.com',
      },
      {
        name: 'Polygon',
        displayName: this.$t('components.about.aboutUsPartners.polygon.string'),
        imgSrc: 'https://static.gala.games/images/about-page/logo_polygon.png',
        link: 'https://www.polygon.technology',
      },
    ];
  }
}
